import { Select } from "antd";
import * as React from "react";
import { useStoreActions, useStoreState } from "../../store/hooks/easyPeasy";
const { Option } = Select;

export interface SelectPackageCustom {
  onChange?: any;
  selected?: any;
  defaultSelected?: any;
  style?: any
}

export const SelectPackageCustom = ({
  onChange,
  selected,
  defaultSelected,
  style
}: SelectPackageCustom) => {

  const itemList = useStoreState((state) => state.order.packageListByProductId);
  const onSelect = (id) => {
    if (itemList) {
      const val = itemList.find((item) => item.packageId === id);
      onChange(val);
    }
  };

  return (
    <Select
      onChange={onSelect}
      // loading={loading}
      showSearch
      // allowClear
      defaultValue={defaultSelected}
      value={selected}
      style={style}
      placeholder="Select Package"
      filterOption={(input, option) =>
        option !== undefined &&
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {itemList ? (
        itemList.map((type, idx) => (
          <Option key={type.packageId} value={type.packageId}>
            {type.packageName}
          </Option>
        ))
      ) : (
        <Option value="fetching">Fetching Packages</Option>
      )}
    </Select>
  );
};
